// navigation.js

const body = document.body;

const navigation = document.querySelector('.block--navigation');
const navigationButtons = document.querySelector('.block--navigation .block--navigation__buttons');
const navigationToggle = document.querySelector('.block--navigation .block--navigation__buttons a[data-action="togglenav"]');
const navigationMenu = document.querySelector('.block--navigation .block--navigation__nav');

// Toggle navigation
function toggleNavigation() {
	navigationToggle?.classList.toggle('active');
	navigationButtons?.classList.toggle('active');
	navigationMenu?.classList.toggle('active');

	// Optional
	body.classList.toggle('js-togglenav');
}

// Event listener
navigationToggle?.addEventListener('click', (event) => {
	event.preventDefault();
	toggleNavigation();
});